export function hashPageScroll() {
  const headerH = $(".l-header").outerHeight(); //ヘッダーの高さ
  if (location.hash !== "") {
    const targetOffset = $(location.hash).offset().top - headerH;
    $(window).scrollTop(targetOffset);
  }
}
